import styled from "styled-components"

import TableWrapper from "components/table/TableWrapper"

export const StyledTableWrapper = styled(TableWrapper)`
  min-height: auto;
`

export const StyledTableNavWrapper = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 25px;
  margin-bottom: 18px;
  row-gap: 6px;
  flex-wrap: wrap;
`
